import {get,put} from './mainApi'; 
import { generateId } from 'src/utils/traceIdGenerations';

const notificationServiceBaseURL =  process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT;

export const getLeaveNotificationDetails = async (employeeId, viewAll = false) => {
  try {
    const traceId = generateId(9);

    let url = `${notificationServiceBaseURL}notification-details?traceId=${traceId}&employeeId=${employeeId}`;
    if (viewAll) {
      url += `&status=Viewall`;
    }

    const response = await get(url);

    return response.data?.data;
  } catch (error) {
    console.error('Error fetching leave notification details:', error);
    throw error;
  }
};

export const updateLeaveNotificationDetails = async (data: { id: number; status: string }[]) => {
  try {
    const traceId = generateId(9);
    const route = `${notificationServiceBaseURL}notification-details?traceId=${traceId}`;
    const requestBody = {data};
    const response = await put(route, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error updating leave notification details:', error);
    throw error;
  }
};